import React from "react";
import PropTypes from "prop-types";

export default function PairingCheck({ mismatches, repairStatus, onRepair }) {
    const successItems = Object.entries(repairStatus)
        .filter(([, status]) => status?.state === "success")
        .filter(([mac]) => !mismatches.some((item) => item.macAddress === mac))
        .map(([mac, status]) => ({ macAddress: mac, message: status.message }));

    if (mismatches.length === 0 && successItems.length === 0) {
        return null;
    }

    return (
        <div className="pairing-check-list">
            {mismatches.map((item) => {
                const status = repairStatus[item.macAddress];
                const updating = status?.state === "updating";
                return (
                    <div key={item.macAddress} className="pairing-check" role="status">
                        <p className="pairing-check-title">Pairing check</p>
                        <p className="pairing-check-body">
                            {item.actuatorDescription} is under {item.dashboardLabel} ({item.dashboardSensor})
                            on the dashboard, but the device reports {item.reportedSensor}.
                        </p>
                        {status?.state === "error" && status.message && (
                            <p className="pairing-check-result pairing-check-result-error">{status.message}</p>
                        )}
                        <button
                            type="button"
                            className="pairing-check-button"
                            onClick={() => onRepair(item.macAddress)}
                            disabled={updating}
                        >
                            {updating ? "Updating device..." : "Update device"}
                        </button>
                    </div>
                );
            })}
            {successItems.map((item) => (
                <div key={item.macAddress} className="pairing-check pairing-check-success" role="status">
                    <p className="pairing-check-result">{item.message}</p>
                </div>
            ))}
        </div>
    );
}

PairingCheck.propTypes = {
    mismatches: PropTypes.arrayOf(PropTypes.shape({
        macAddress: PropTypes.string.isRequired,
        actuatorDescription: PropTypes.string,
        dashboardSensor: PropTypes.string,
        dashboardLabel: PropTypes.string,
        reportedSensor: PropTypes.string,
    })).isRequired,
    repairStatus: PropTypes.object.isRequired,
    onRepair: PropTypes.func.isRequired,
};
